var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardContent = void 0;
var CardContent_1 = __importDefault(require("./CardContent"));
exports.CardContent = CardContent_1.default;
exports.default = CardContent_1.default;
//# sourceMappingURL=index.js.map